<!--Video chart-->
<div class="video-content" [style.width]="'100%'" [style.height]="'100%'" [style]="containerStyle" #htmlContent>
  <div [style]="blockStyle">
    <ng-container *ngIf="showTitle && titlePosition == 'top'">
      @if (richTitle && showTitle) {
<app-widget-title [title]="title" [design]="widget?.design?.title"></app-widget-title>
} @else {
<p [style]="titleStyle" *ngIf="showTitle">{{ title }}</p>
}
    </ng-container>

    <span class="error" *ngIf="error">{{ error }}</span>

    <video *ngIf="video && video.type == 'url'" [style.height]="imageStyle" (click)="onImgClick()" preload="auto"
      responsive="true" fuild="true" controls name="media" autoplay="{{video.autoplay ? 'autoplay' : '' }}">
      <source [src]="video.url" [type]="video.format">
    </video>

    <video *ngIf="video && video.type == 'mediastream'" #remoteVideo muted playsinline allowfullscreen="true"
      [controls]="started && ready && !streamLimitReached" [ngClass]="{ 'not-ready': !ready }" (click)="onVideoClick()"
      (play)="onVideoPlay()" (pause)="onVideoPause()" (playing)="onStreamLive()">
    </video>

    <div *ngIf="video && video.type == 'mediastream' && !started && !noStream && !streamLimitReached" class="play-overlay">
      <lib-button icon="play_arrow" color="muted" size="large" tooltip="Play stream" (click)="startStream()"></lib-button>
      <span *ngIf="streamUsageLabel" class="usage">{{ streamUsageLabel }}</span>
    </div>

    <div *ngIf="video && video.type == 'mediastream' && started && !ready && !noStream && !streamLimitReached"
      class="loading-overlay">
      <span class="spinner"></span>
    </div>

    <div *ngIf="video && video.type == 'mediastream' && noStream && !ready && !streamLimitReached" class="limit-overlay">
      <lib-button icon="videocam_off" color="muted" size="large" tooltip="Retry" (click)="startStream()"></lib-button>
      <span>{{ 'dashboard.video.noStream' | translate }}</span>
    </div>

    <div *ngIf="video && video.type == 'mediastream' && streamLimitReached" class="limit-overlay">
      <lib-button icon="block" color="muted" size="large" [disabled]="true"></lib-button>
      <span>{{ 'dashboard.video.limitReached' | translate: { duration: streamLimitDuration } }}</span>
    </div>

    <span *ngIf="video && video.type == 'mediastream' && started && !streamLimitReached && streamUsageLabel"
      class="usage-badge">{{ streamUsageLabel }}</span>

    @if (video?.type === 'youtube') {
      <!-- The YouTube player is heavy: its thumbnail until played (the embed link never autoplayed anyway) -->
      @if (youtubeStarted || !youtubeId) {
        <iframe [src]="youtubeSrc | safe" width="100%" height="100%" [title]="title || 'YouTube'"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
        </iframe>
      } @else {
        <div class="youtube-facade" [style.background-image]="'url(https://i.ytimg.com/vi/' + youtubeId + '/hqdefault.jpg)'">
          <lib-button icon="play_arrow" color="primary" size="large" (click)="youtubeStarted = true"></lib-button>
        </div>
      }
    }

    <ng-container *ngIf="showTitle && titlePosition != 'top'">
      @if (richTitle && showTitle) {
<app-widget-title [title]="title" [design]="widget?.design?.title"></app-widget-title>
} @else {
<p [style]="titleStyle" *ngIf="showTitle">{{ title }}</p>
}
      <span class="error" *ngIf="error">{{ error }}</span>
    </ng-container>
  </div>

  @if (widgetRendered) {
  <div id="chart-rendered"></div>
  }
</div>
